<template>
  <v-dialog persistent :value="isOpen" max-width="290" overlay-color="white" id="show-modal" overlay-opacity="0.8">
    <v-card class="pb-4 pt-2 rounded-xl text-align-center">
      <v-card-title class="text-body-1 confirmation-dialog__title justify-center">
        {{ title }}
      </v-card-title>

      <v-card-text v-if="!!body" class="subtitle-2 confirmation-dialog__body justify-center text-align-center">
        {{ body }}
      </v-card-text>

      <v-card-actions>
        <div class="confirmation-dialog__yes-container" v-if="yesText">
          <PrimaryButton @click="$emit(`yes`)" :height="45">
            {{ yesText }}
          </PrimaryButton>
        </div>
        <div class="confirmation-dialog__yes-container ml-3" v-if="noText">
          <SecondaryButton @click="$emit(`no`)" :height="45">
            {{ noText }}
          </SecondaryButton>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
.confirmation-dialog__title {
  font-weight: 600 !important;
  word-break: unset !important;
  color: var(--v-accent-text-base)
}

.confirmation-dialog__body {
  color: var(--v-body-text-base) !important;
  text-align: center;
}
.confirmation-dialog__yes-container {
  width: 100%;
}

.confirmation-dialog__yes {
  height: 45px !important;

  span {
    font-weight: 600;
  }
}
</style>

<script lang="ts">
import Vue from 'vue'
import SecondaryButton from '@/components/SecondaryButton.vue'
import PrimaryButton from '@/components/PrimaryButton.vue'

export default Vue.extend({
  name: 'ConfirmationDialog',

  props: {
    isOpen: Boolean,
    title: String,
    body: {
      type: String,
      required: false,
    },
    yesText: {
      type: String,
    },
    noText: {
      type: String,
    },
  },

  components: {
    SecondaryButton,
    PrimaryButton,
  },
})
</script>
